module.exports = __webpack_public_path__ + "assets/font/Anuphan-Regular-64903019.ttf";